module.exports = __webpack_public_path__ + "static/media/hero2.c0fa3294.png";